import React from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import MatchingGamePage from './MatchingGamePage';

const MatchingGamePageWrapper: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const location = useLocation();

  if (!id) {
    return <div>Invalid set ID</div>;
  }

  const handleBack = () => {
    const params = new URLSearchParams(window.location.search);
    const from = params.get('from');
    const folderId = params.get('folderId');
    const baseUrl = location.pathname.startsWith('/student') ? '/student/flashcards' : '/flashcards';
    let url = `${baseUrl}/sets/${id}/detail`;
    if (from && folderId) {
      url += `?from=${from}&folderId=${folderId}`;
    }
    navigate(url);
  };

  return (
    <MatchingGamePage
      setId={Number(id)}
      onBack={handleBack}
      challengeState={(location.state as any)?.isChallenge ? {
        challengeId: (location.state as any)?.challengeId,
        isChallenge: true,
        gameType: (location.state as any)?.gameType,
        isAccepter: (location.state as any)?.isAccepter || false,
      } : null}
    />
  );
};

export default MatchingGamePageWrapper;
